<template>
  <section>
    <div class="card panel-white">
      <div class="card-body panel-cleaner">
        <div class="text-left">
          <label>{{ $t('message.my_reservations.cleaner') }}</label>
          <div class="mt-2">
            <template v-if="order.professional">
              <!-- Profile -->
              <div class="d-flex justify-content-start align-items-center">
                <div>
                  <a href="" @click.prevent="openProfessionalDetail(order.professional)">
                    <professional-picture :professional="order.professional" 
                                          :imgClass="order.declined_order_data && order.status === 0 ? 'border border-danger' : ''"
                                          :imgSize="56"/>
                  </a>
                </div>
                <div class="flex-fill pl-3">
                  <a href="" @click.prevent="openProfessionalDetail(order.professional)" class="text-reset">
                    {{ order.professional_name | firstName }}
                  </a>
                  <!-- Declined or pending status -->
                  <div class="text-small" v-if="order.status === 0 && order.cleaning_date">
                    <template v-if="order.declined_order_data">
                      <div class="-status-alert">
                        <span class="bullet-notification">
                          <i class="fas fa-circle -status-alert"></i>
                        </span>
                        {{ $t('message.professional.job_status.declined') }}
                      </div>
                      <div class="-status-alert">
                        - {{ order.declined_order_data | declinedReason }}
                      </div>
                    </template>
                    <template v-else>
                      <div class="-status-pending">
                        <span class="bullet-notification">
                          <i class="fas fa-circle -status-pending"></i>
                        </span>
                        {{ $t('message.my_reservations.waiting') }}
                      </div>
                    </template>
                  </div>
                  <!-- Professional job status -->
                  <div class="text-small" v-else-if="order.status > 0" v-html="$options.filters.professionalJobStatus(order, true)"></div>
                </div>
              </div>

              <!-- Contact -->
              <div class="row no-gutters pt-3" v-if="order.status > 0">
                <div class="col" v-if="isAbleCallCleaner(order)"
                     :class="{'pr-2' : (isAbleChatCleaner(order) && user)}">
                  <a :href="'tel:'+ order.professional.phone" class="btn btn-outline-info btn-block">
                    <i class="fas fa-phone"></i> {{ $t('message.button.call') }}
                  </a>
                </div>
                <div class="col" v-if="isAbleChatCleaner(order) && user"
                     :class="{'pl-2': isAbleCallCleaner(order)}">
                  <router-link
                    :to="{ path: '/message', query: { cid: order.chat_room_id, pid:order.professional_id }}"
                    class="btn btn-outline-info btn-block">
                    <i class="fas fa-comment-alt-lines"></i> {{ $t('message.button.chat') }}
                  </router-link>
                </div>
              </div>

              <!-- Transportation -->
              <div class="pt-4" v-if="order.professional.transportation_type && !order.declined_order_data && order.status > 0">
                <label>{{ $t('message.my_reservations.transportation_type') }}</label>
                <div>
                  <span v-html="$options.filters.transportationTypeIcon(order.professional.transportation_type)"></span>
                  {{ order.professional.transportation_type | multiLangName }}
                </div>
              </div>
            </template>

            <template v-else>
              <div class="d-flex justify-content-start align-items-center">
                <div>
                  <img src="https://beneat.co/static/img/unknown.png"
                       width="56"
                       class="rounded-circle">
                </div>
                <div class="text-remark ml-2">
                  <span v-if="!order.cleaning_date && order.is_no_datetime_booking === 1">
                     {{ $t('message.my_reservations.service_provider_not_specified') }}
                  </span>
                  <span v-else>
                    {{ $t('message.my_reservations.finding_new_cleaner') }}
                  </span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- Pre-booking Professional Selection Section -->
        <pre-booking-professional-selection-section :imgSize="imgSize" :order="order" />
      </div>
    </div>
  </section>
</template>

<script>
  import moment from 'moment-timezone'
  import { mapGetters } from 'vuex'
  import PreBookingProfessionalSelectionSection from './PreBookingProfessionalSelectionSection'
  import ProfessionalPicture from '../../professional/components/ProfessionalPicture'

  export default {
    props: {
      order: Object,
      imgSize: Number
    },
    components: {
      ProfessionalPicture,
      PreBookingProfessionalSelectionSection
    },
    data () {
      return {
        validation: null
      }
    },
    computed: {
      ...mapGetters({
        state: 'orderDetail/getState',
        user: 'auth/getUser',
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      openProfessionalDetail (professional) {
        let numServices = 0
        numServices += professional.professional_services.length
        if (professional.experiences) {
          numServices += professional.experiences.length
        }
        if (numServices > 1) {
          this.$parent.$parent.openProfessionalServiceModal(professional)
        } else {
          if (professional.professional_services && professional.professional_services.length > 0) {
            this.$router.push('/cleaner/' + professional.id)
          } else if (professional.experiences && professional.experiences.length > 0) {
            this.$router.push('/special-services/' + professional.experiences[0].id)
          }
        }
      },
      isAbleChatCleaner (order) {
        let result = true
        if (order.paid_status === 0) {
          result = false
        }
        return result
      },
      isAbleCallCleaner (order) {
        let result = false
        const given = moment(order.cleaning_date, 'YYYY-MM-DD HH:mm:ss')
        const current = moment().format('YYYY-MM-DD HH:mm:ss')
        const converted = moment(current, 'YYYY-MM-DD HH:mm:ss')
        const diffHours = moment.duration(converted.diff(given)).asHours()

        if (order.status > 0 && order.cancel === 0 && diffHours <= 24) {
          result = true
        }

        return result
      }
    },
    mounted () {
      if (this.$route.query.validation) {
        this.validation = this.$route.query.validation
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/MyCleaner.vue